import classes from "./OurVision.module.scss";
import Comment from "../../../assets/icons/Comment";

const OurVision = () => {
  return (
    <div className={classes["our-vision-section"]}>
      <div className={classes["our-vision-comment-container"]}>
        <div className={classes["comment-svg-left"]}>
          <Comment isStartQuote={true} />
        </div>

        <p className={classes["our-vision-text"]}>Our Vision</p>
      </div>

      <div className={classes["our-vision-para"]}>
        <p className={classes["first-para"]}>
          Converging <b className={classes["black-text"]}>AI</b> and <b className={classes["black-text"]} >Clean Energy </b>
          for a <span>Greener Tomorrow</span>
        </p>
      </div>

      <div className={classes["comment-svg-right"]}>
        <Comment />
      </div>
    </div>
  );
};

export default OurVision;
